/** Used when live support is in demo mode or the socket is not available. */
export function simulatedAdminReply(userText) {
  const t = String(userText || "")
    .toLowerCase()
    .trim();
  if (/\b(urgent|emergency|severe pain)\b/.test(t)) {
    return "If this is a medical emergency, please call your local emergency number right away. For non-emergency care navigation, tell me your request ID or what step you are stuck on.";
  }
  if (/\b(refund|cancel|complaint)\b/.test(t)) {
    return "I have logged that. A coordinator will review account and billing details and reply here. Anything else I should add to the note?";
  }
  if (/\b(bid|doctor|hospital)\b/.test(t)) {
    return "Thanks for the detail. I see the bidding flow — if bids look unusual or a doctor is unresponsive, say which request and we will nudge the right parties.";
  }
  return "Thanks for waiting — this is Alex from the care team. I am here with you in real time now. Tell me what is going wrong or what you need, and we will sort it out step by step.";
}
